<template>
  <v-dialog v-model="open" width="650px">
    <v-card dense>
      <v-toolbar elevation="0">
        <v-toolbar-title
          class="text--subtitle error--text"
          style="padding-left: 10px"
        >
          <v-icon color="error" style="padding-bottom: 2px"
            >mdi-play-box-multiple-outline</v-icon
          >
          {{
            $t('message.pages.AbTest.removeTest', {
              quantity: quantityToRemove,
            })
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="handleCloseModal()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="px-7 py-0">
        <v-row no-gutters>
          <v-col cols="12">
            {{
              $t('message.pages.AbTest.removeMessage', {
                count: quantityToRemove,
              })
            }}
            <br />
            {{ $t('message.pages.AbTest.confirmRemoveMessage') }}
          </v-col>
          <v-col cols="12" class="my-3">
            <b>{{ $t('message.pleaseConfirmRemove') }}</b>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="removeText"
              :placeholder="$t('message.remove')"
              dense
              outlined
              autofocus
              @keyup.enter="handleConfirmDelete"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-7 pb-6">
        <v-spacer></v-spacer>
        <v-btn class="mr-4" text @click="handleCloseModal">
          {{ $t('message.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          class="white--text"
          @click="handleClickRemoveTest"
          :loading="isRemovingTest"
          :disabled="!removeVerification || isRemovingTest"
        >
          <span class="px-5">{{ $t('message.confirm') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/translations/lang.js'

export default {
  name: 'RemoveTestModal',
  props: {
    openRemove: {
      type: Boolean,
      required: true,
    },
    quantityToRemove: {
      type: Number,
      default: 0,
    },
    isRemovingTest: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({
    removeText: '',
  }),
  watch: {
    openRemove(value) {
      if (!value) {
        this.removeText = ''
      }
    },
  },
  methods: {
    handleCloseModal() {
      this.$emit('close')
    },
    handleConfirmDelete() {
      if (this.removeVerification) {
        this.handleClickRemoveTest()
      }
    },
    handleClickRemoveTest() {
      this.$emit('remove')
    },
  },
  computed: {
    removeVerification() {
      return (
        this.removeText.toUpperCase() === i18n.t('message.remove').toUpperCase()
      )
    },
    open: {
      get() {
        return this.openRemove
      },
      set(newValue) {
        if (!newValue) this.$emit('close')
      },
    },
  },
}
</script>
